import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const BreadcrumbsWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.neutral.white};
        border-radius: ${radius[8]}px;
        border: 1px solid ${palette.neutral.dividers};
        display: flex;
        gap: 10px;
        padding: 16px 24px;
        width: fit-content;

        @media (max-width: ${breakpoints.sm}px) {
            padding: 12px 16px;
        }
    `,
);

export const HomeLink = styled(Link)`
    text-decoration: none;
`;

export const HomeText = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        text-decoration: none;
    `,
);

export const Divider = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.neutral.dividers};
    `,
);

export const PathText = styled(Typography.TextBody_14_20)(
    ({ theme: { fontWeight, palette } }) => css`
        font-weight: ${fontWeight.bold};
        overflow: hidden;
        position: relative;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media (max-width: ${breakpoints.sm}px) {
            max-width: 246px;
        }

        @media (max-width: ${breakpoints.xxs}px) {
            max-width: 190px;
        }

        &::after {
            background-color: ${palette.primary.default};
            bottom: 0;
            content: '';
            height: 1px;
            left: 0;
            position: absolute;
            width: 100%;
        }
    `,
);
